import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  LayoutDashboard,
  Users,
  Euro,
  FileText,
  Settings,
  Shield,
  LogOut,
  TrendingUp,
  Upload,
  Eye,
  MessageSquare
} from 'lucide-react';
import { Button } from './ui/button';
import { Avatar, AvatarFallback } from './ui/avatar';
import SofincoLogo from './SofincoLogo';

const AdminSidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const menuItems = [
    { icon: LayoutDashboard, label: 'Tableau de bord', path: '/admin/dashboard' },
    { icon: Users, label: 'Gestion des clients', path: '/admin/clients' },
    { icon: Euro, label: 'Gestion des fonds', path: '/admin/funds' },
    { icon: FileText, label: 'Demandes de crédit', path: '/admin/credit-requests' },
    { icon: Eye, label: 'Données clients', path: '/admin/client-data' },
    { icon: MessageSquare, label: 'Messages & Contact', path: '/admin/messages' },
  ];

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="w-64 bg-gray-900 min-h-screen flex flex-col text-white">
      {/* Logo - Black */}
      <div className="p-6 border-b border-gray-800 bg-black">
        <Link to="/admin/dashboard">
          <img 
            src="https://customer-assets.emergentagent.com/job_younited-clone-1/artifacts/y6hpz6h2_IMG_0359.jpeg"
            alt="Younited"
            className="h-10 object-contain"
          />
        </Link>
        <p className="text-xs text-gray-400 mt-2">Panneau Administrateur</p>
      </div>

      {/* Profile */}
      <div className="p-6 border-b border-gray-800">
        <div className="flex items-center space-x-3">
          <Avatar className="h-10 w-10 bg-purple-600">
            <AvatarFallback className="bg-purple-600 text-white">
              {user?.firstName?.charAt(0)}{user?.lastName?.charAt(0)}
            </AvatarFallback>
          </Avatar>
          <div>
            <p className="font-semibold text-sm">{user?.firstName} {user?.lastName}</p>
            <p className="text-xs text-gray-400">Administrateur</p>
          </div>
        </div>
      </div>

      {/* Menu */}
      <nav className="flex-1 py-4">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;

          return (
            <Link
              key={item.path}
              to={item.path}
              className={`
                flex items-center px-6 py-3 text-sm font-medium transition-colors
                ${
                  isActive
                    ? 'bg-purple-600 text-white'
                    : 'text-gray-300 hover:bg-gray-800 hover:text-white'
                }
              `}
            >
              <Icon className="h-5 w-5 mr-3" />
              {item.label}
            </Link>
          );
        })}
      </nav>

      {/* Bottom Actions */}
      <div className="p-4 border-t border-gray-800">
        <Button
          variant="ghost"
          className="w-full justify-start text-gray-300 hover:bg-gray-800 hover:text-white"
          onClick={handleLogout}
        >
          <LogOut className="h-5 w-5 mr-3" />
          Déconnexion
        </Button>
      </div>
    </div>
  );
};

export default AdminSidebar;
